// Builds a print-ready HTML document for an invoice/quote and opens the
// browser print dialog (where the user can "Save as PDF").
export function printDocument(doc) {
    const money = (v) => `$${Number(v || 0).toFixed(2)}`;
    const kind = doc.type === "quote" ? "Quote" : "Invoice";

    const rows = (doc.line_items || []).map((l) => `
        <tr>
          <td>${escapeHtml(l.description)}</td>
          <td class="num">${Number(l.quantity)}</td>
          <td class="num">${money(l.unit_price)}</td>
          <td class="num">${money(l.amount)}</td>
        </tr>`).join("");

    const discountRow = Number(doc.discount) > 0
        ? `<tr><td colspan="3" class="num muted">Discount</td><td class="num">-${money(doc.discount)}</td></tr>` : "";

    const html = `<!doctype html><html><head><meta charset="utf-8"><title>${kind} ${doc.number}</title>
      <style>
        * { box-sizing: border-box; }
        body { font-family: Georgia, 'Times New Roman', serif; color: #1A1A1A; margin: 48px; }
        .top { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:3px solid #0F4C15; padding-bottom:20px; }
        .brand { font-size:26px; font-weight:bold; color:#0F4C15; }
        .brand small { display:block; font-size:11px; letter-spacing:3px; color:#B8860B; text-transform:uppercase; font-family:Arial; margin-top:4px; }
        .kind { text-align:right; }
        .kind h1 { margin:0; font-size:30px; letter-spacing:2px; }
        .kind .num { font-family:monospace; color:#555; }
        .meta { display:flex; justify-content:space-between; margin:24px 0; font-size:13px; }
        .meta .label { font-family:Arial; font-size:10px; letter-spacing:2px; text-transform:uppercase; color:#0F4C15; }
        table { width:100%; border-collapse:collapse; margin-top:12px; font-size:14px; }
        thead th { background:#0F4C15; color:#FAF8F5; text-align:left; padding:10px 12px; font-family:Arial; font-size:11px; letter-spacing:1px; text-transform:uppercase; }
        thead th.num, td.num { text-align:right; }
        tbody td { padding:10px 12px; border-bottom:1px solid #e7e2da; }
        .muted { color:#777; }
        .total-row td { font-weight:bold; font-size:17px; padding-top:16px; }
        .notes { margin-top:28px; font-size:13px; color:#555; }
        .foot { margin-top:40px; font-size:12px; color:#888; text-align:center; border-top:1px solid #e7e2da; padding-top:16px; }
        @media print { body { margin:24px; } }
      </style></head><body>
      <div class="top">
        <div class="brand">Wild Coffee Retreat<small>Kotch pon a Rock · Negril, Jamaica</small></div>
        <div class="kind"><h1>${escapeHtml(kind.toUpperCase())}</h1><div class="num">${escapeHtml(doc.number)}</div>
          <div style="margin-top:6px;font-family:Arial;font-size:11px;text-transform:uppercase;letter-spacing:1px;">${escapeHtml(doc.status)}</div></div>
      </div>
      <div class="meta">
        <div><div class="label">Billed to</div><div>${escapeHtml(doc.guest_name || "—")}</div><div class="muted">${escapeHtml(doc.guest_email || "")}</div></div>
        <div style="text-align:right;"><div class="label">Issued</div><div>${escapeHtml(doc.issue_date || "")}</div>
          ${doc.due_date ? `<div class="label" style="margin-top:8px;">Due</div><div>${escapeHtml(doc.due_date)}</div>` : ""}</div>
      </div>
      <table>
        <thead><tr><th>Description</th><th class="num">Qty</th><th class="num">Unit</th><th class="num">Amount</th></tr></thead>
        <tbody>
          ${rows}
          ${discountRow}
          <tr class="total-row"><td colspan="3" class="num">Total</td><td class="num">${money(doc.total)}</td></tr>
        </tbody>
      </table>
      ${doc.notes ? `<div class="notes">${escapeHtml(doc.notes)}</div>` : ""}
      <div class="foot">Thank you — Wild Coffee Retreat</div>
      <script>window.onload = function(){ window.print(); };</script>
      </body></html>`;

    const w = window.open("", "_blank", "width=820,height=920");
    if (!w) return;
    // Render the print document via a Blob URL (no legacy synchronous DOM writes).
    const blob = new Blob([html], { type: "text/html" });
    w.location.href = URL.createObjectURL(blob);
}

function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}
